import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["readonly", "placeholder", "maxlength"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(["flex flex-1 w-0 text-right mr-6 text-portal-darkgrey", { readonly: _ctx.readonly, focus: _ctx.isFocus }]),
    readonly: _ctx.readonly,
    placeholder: _ctx.placeholder,
    maxlength: _ctx.maxLength,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bindValue) = $event)),
    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.insert && _ctx.insert(...args))),
    onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
    onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args)))
  }, null, 42, _hoisted_1)), [
    [_vModelText, _ctx.bindValue]
  ])
}